import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import AntiFraudToolService from '../../../Services/AntiFraudToolService';
import FraudHitMatchSearchParams from './FraudHitMatchSearchParams';
import FraudHitEvaluatorMatchItem from '../../../Domain/FraudHitEvaluatorMatchItem';

export default class MatchMatrixTab extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    const searchParams = new FraudHitMatchSearchParams();
    searchParams.FraudHitEvaluatorId = props.fraudHitEvaluatorId;

    this.state = {
      searchItem: searchParams,
      selectedFraudHitEvaluator: null,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <TabOfDataTable
        type={FraudHitEvaluatorMatchItem}
        serviceFunction={AntiFraudToolService.GetAllMatchesBySearching}
        convertDBItemsFunction={AntiFraudToolService.ConvertMatchesDBItemList}
        searchItem={this.state.searchItem}
        orderDirection={OrderDirectionsEnum.Desc}
        orderBy={'FraudHitEvaluatorMatchId'}
        showSearchStrip={false}
        singleSearchLine={false}
        searchParamsType={FraudHitMatchSearchParams}
        enableUrlPush={false}
        errorCode='MMT37'
      />
    );
  }
}
